import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import Paciente from "@/pages/admin/Paciente";
import { pageHead } from "@/lib/seo";

// "plano", "agenda" e "plataforma" são telas só do celular (no computador ficam na visão geral).
const busca = z.object({
  aba: z
    .enum([
      "visao-geral",
      "dieta",
      "evolucao",
      "linha-do-tempo",
      "formularios",
      "contratos",
      "pagamentos",
      "app",
      "dados",
      "plano",
      "agenda",
      "plataforma",
    ])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute("/admin/pacientes/$id")({
  validateSearch: busca,
  head: () => pageHead({ title: "Paciente | Painel", path: "/admin/pacientes", noindex: true }),
  component: Paciente,
});
